<template>
  <div class="my-8">
    <div class="my-1 text-secondary_text">
      {{$t('profile.other-places')}} {{$t('profile.more-than-a-year')}}
    </div>

    <div class="flex flex-col">
      <table class="w-full">
        <tr class="border-t h-12 border-line">
          <td class="mr-1">{{residenceCountry}}</td>
          <td class="ml-1">{{residenceRegion}}</td>
          <td></td>
        </tr>
        <tr class="border-t h-12 border-b border-line" v-for="(op, i) of valueCopy" :key="`op-${i}`" >
          <td class="mr-1">{{op.country}}</td>
          <td class="mx-1">{{op.region}}</td>
          <td class="mx-1 w-6">
            <button class="ml-1" @click="remove(i)">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45" height="24" width="24"><path d="M39.75 9.4h-8.42V7.75a1.82 1.82 0 00-1.82-1.82H16.2a1.82 1.82 0 00-1.82 1.82v1.67H6.26a.68.68 0 100 1.36h4.1v24.61a2.96 2.96 0 002.96 2.96H32.4a2.96 2.96 0 002.96-2.96v-24.6h4.4a.68.68 0 000-1.37zm-24-1.66a.46.46 0 01.46-.45h13.3a.46.46 0 01.45.45v1.67H15.75zM34 35.38a1.6 1.6 0 01-1.6 1.6H13.32a1.6 1.6 0 01-1.6-1.6v-24.6h22.27z"/><path d="M16.92 15.41a.68.68 0 00-.68.69v15.96a.68.68 0 101.36 0V16.1a.68.68 0 00-.68-.69zM22.89 15.41a.68.68 0 00-.69.69v15.96a.68.68 0 101.37 0V16.1a.68.68 0 00-.68-.69zM28.81 15.41a.68.68 0 00-.68.69v15.96a.68.68 0 101.37 0V16.1a.68.68 0 00-.69-.69z"/></svg>
            </button>
          </td>
        </tr>
      </table>

      <div class="py-2" v-if="addingNewPlace && canAddMorePlaces" >
        <otherplace-editor @input="pushNewPlace($event)" />
      </div>

      <div class="flex flex-col py-2">
        <plus-button v-if="!addingNewPlace && canAddMorePlaces" @click="addingNewPlace = true">{{$t('profile.add-place')}}</plus-button>
      </div>

      <div class="text-xs text-secondary_text mb-4 px-3">
        Indicare i luoghi in cui hai vissuto per almeno un anno per motivi familiari, di studio o di lavoro.
      </div>
    </div>
  </div>
</template>

<script>
import OtherplaceEditor from '@/components/OtherplaceEditor'
import PlusButtonVue from '@/components/PlusButton.vue'

export default {
  props: {
    residenceCountry: String,
    residenceRegion: String,
    value: Array
  },
  data() {
    return {
      addingNewPlace: false,
      valueCopy: this.value
    }
  },
  components: {
    OtherplaceEditor,
    PlusButton: PlusButtonVue,
  },
  computed: {
    canAddMorePlaces() {
      if(this.residenceCountry != 'CH' && this.residenceCountry != 'IT') {
        return false
      }
      if(!this.residenceRegion) {
        return false
      }
      return true
    }
  },

  watch: {
    residenceCountry() {
      this.checkForDuplicates()
    },
    residenceRegion() {
      this.checkForDuplicates()
    }
  },
  
  methods: {
    remove(index) {
      this.valueCopy.splice(index, 1)
      this.$emit('input', this.valueCopy)
    },
    checkForDuplicates() {
      this.valueCopy = this.valueCopy.filter(place => {
        if(this.residenceCountry == place.country && this.residenceRegion == place.region) {
          return false
        }
        return true
      })
      this.$emit('input', this.valueCopy)
    },
    pushNewPlace(place) {
      //check validity
      if(!place.country) {
        return false;
      }
      if((place.country == 'CH' || place.country == 'IT') && !place.region) {
        return false;
      }

      this.addingNewPlace = false

      //check for duplicates
      if(this.valueCopy.filter(p => p.country == place.country && p.region == place.region).length) {
        return false
      }
      if(this.residenceCountry == place.country && this.residenceRegion == place.region) {
        return false
      }

      this.valueCopy.push(place)
      this.$emit('input', this.valueCopy)
    }
  }

}
</script>

<style>

</style>